import { PropsWithChildren } from "react";
import { RequiresAuthenticationIf } from "./requires-authentication-if.component";

export function RequiresAuthentication({ children }: PropsWithChildren) {
  return (
    <RequiresAuthenticationIf requiresAuthentication>
      {children}
    </RequiresAuthenticationIf>
  );
}
